/**
 * @param marketoForm {MarketoForm}
 * @return {string}
 */
module.exports = function getCountryOptionsHtmlFromTheMarketoForm(marketoForm) {
    const countryOptions = marketoForm.getFormElem()
        .find("[name=Country]")
        .find("option");

    let unitedStatesOption = null;
    let unitedKingdomOption = null;
    let canadaOption = null;

    let options = "";
    for (const option of countryOptions) {
        const value = option.getAttribute("value");
        if (value) {
            const newOption = `<option value="${value}">${option.innerText}</option>`;

            if (value === "United States") {
                unitedStatesOption = newOption;
            } else if (value === "United Kingdom") {
                unitedKingdomOption = newOption;
            } else if (value === "Canada") {
                canadaOption = newOption;
            } else {
                options += newOption;
            }
        }
    }

    const defaultOption = `<option value="">Country/Permanent Residence</option>`;

    options = defaultOption + unitedStatesOption + unitedKingdomOption + canadaOption + options;

    return options;
}